import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaDesktop,
  FaRobot,
  FaTwitter,
  FaDiscord,
  FaUserShield,
  FaHeadset,
  FaPaintBrush,
  FaVideo,
  FaShoppingCart,
  FaArrowRight,
  FaTimes,
  FaInfoCircle,
  FaComments
} from "react-icons/fa";

  const Services = ({ isDarkMode }) => {

    const navigate = useNavigate();

    const [activeIndex, setActiveIndex] = useState(null);
    const [hoverIndex, setHoverIndex] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedService, setSelectedService] = useState(null);

    const services = [
    {
      id: "web",
      icon: <FaLaptopCode size={40} color="#4F46E5" />,
      title: "Web Development",
      desc: "Custom web development services for modern businesses. We build fast, responsive, and scalable websites & web applications for global clients.",
      hasDetails: false
    },
    {
      id: "mobile",
      icon: <FaMobileAlt size={40} color="#10B981" />,
      title: "Mobile App Development",
      desc: "Android and cross-platform mobile app development services with modern UI/UX, optimized performance, and global scalability.",
      hasDetails: false
    },
    {
      id: "desktop",
      icon: <FaDesktop size={40} color="#F59E0B" />,
      title: "Desktop Applications",
      desc: "Custom desktop software development for Windows, macOS, and Linux to automate workflows and improve business productivity.",
      hasDetails: false
    },
    {
      id: "automation",
      icon: <FaRobot size={40} color="#EC4899" />,
      title: "Business Automation",
      desc: "We design automation systems, bots, and workflow solutions to help businesses save time, reduce costs, and scale efficiently.",
      hasDetails: false
    },
    {
      id: "twitter",
      icon: <FaTwitter size={40} color="#1DA1F2" />,
      title: "Twitter Marketing",
      desc: "Professional Twitter marketing services to promote your brand, project, or crypto community through strategic engagement.",
      hasDetails: false
    },
    {
      id: "discord",
      icon: <FaDiscord size={40} color="#5865F2" />,
      title: "Discord Community Marketing",
      desc: "Grow and manage your Discord community with targeted engagement, moderation support, and marketing strategies.",
      hasDetails: false
    },
    {
      id: "moderator",
      icon: <FaUserShield size={40} color="#EF4444" />,
      title: "Hire a Community Moderator",
      desc: "Professional moderators for Discord, Telegram, and online communities to ensure safety, engagement, and proper management.",
      hasDetails: true
    },
    {
      id: "livechat",
      icon: <FaHeadset size={40} color="#14B8A6" />,
      title: "24/7 Live Chat Support",
      desc: "Dedicated live chat agents to provide real-time customer support and improve user satisfaction for your business.",
      hasDetails: true
    },
    {
      id: "graphics",
      icon: <FaPaintBrush size={40} color="#8B5CF6" />,
      title: "Graphic Design",
      desc: "Creative branding, UI/UX design, social media banners, and professional visual identity for modern businesses.",
      hasDetails: false
    },
    {
      id: "video",
      icon: <FaVideo size={40} color="#F43F5E" />,
      title: "Video & Motion Design",
      desc: "High-quality video editing, motion graphics, and animations to enhance your brand storytelling and marketing impact.",
      hasDetails: false
    }
  ];

  const handleServiceClick = (service, e) => {
    // Stop event propagation if clicking on badge
    if (e) e.stopPropagation();
    
    if (service.hasDetails) {
      // If hasDetails is true, navigate to service details page
      navigate(`/service/${service.id}`);
    } else {
      // If hasDetails is false, show inquiry popup
      setSelectedService(service);
      setShowPopup(true);
    }
  };

  const handleCardClick = (service) => {
    if (service.hasDetails) {
      navigate(`/service/${service.id}`);
    } else {
      setSelectedService(service);
      setShowPopup(true);
    }
  };

  const handleGoToContact = () => {
    setShowPopup(false);
    setSelectedService(null);
    
    const contactSection = document.getElementById("contactus");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = "/#contactus";
    }
  };

  const getBackgroundColor = (index) => {
    if (activeIndex === index) {
      return isDarkMode
        ? "rgba(255,223,0,0.25)"
        : "rgba(245,245,245,1)";
    }

    if (hoverIndex === index) {
      return isDarkMode
        ? "rgba(255,223,0,0.15)"
        : "rgba(250,250,250,1)";
    }

    return isDarkMode
      ? "rgba(20,25,45,0.8)"
      : "rgba(255,255,255,0.85)";
  };

  const sectionBackground = isDarkMode
    ? "linear-gradient(135deg, #1a1f36 0%, #2a2145 100%)"
    : "#f8f9fa";

  const sectionTextColor = isDarkMode ? "#f0f0f5" : "#111";

  return (
    <>
      {/* Professional Inquiry Popup Modal */}
      {showPopup && selectedService && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.7)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
            animation: "fadeIn 0.3s ease-out"
          }}
          onClick={() => setShowPopup(false)}
        >
          <div
            style={{
              background: isDarkMode ? "#1e293b" : "#ffffff",
              borderRadius: "24px",
              padding: "40px",
              maxWidth: "480px",
              width: "100%",
              position: "relative",
              boxShadow: "0 25px 50px -12px rgba(0,0,0,0.35)",
              textAlign: "center",
              animation: "slideUp 0.3s ease-out",
              border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)"}`
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowPopup(false)}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: isDarkMode ? "#94a3b8" : "#666",
                transition: "color 0.3s ease",
                padding: "5px"
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#FF4444"}
              onMouseLeave={(e) => e.currentTarget.style.color = isDarkMode ? "#94a3b8" : "#666"}
            >
              <FaTimes />
            </button>

            {/* Service Icon */}
            <div
              style={{
                width: "80px",
                height: "80px",
                background: `linear-gradient(135deg, #FF4444, #FF6B6B)`,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                boxShadow: "0 10px 25px rgba(255,68,68,0.3)"
              }}
            >
              <div style={{ transform: "scale(1.2)" }}>
                {React.cloneElement(selectedService.icon, { size: 40, color: "#fff" })}
              </div>
            </div>

            {/* Service Title */}
            <h2
              style={{
                fontSize: "28px",
                marginBottom: "12px",
                color: isDarkMode ? "#fff" : "#1a1f36",
                fontWeight: "bold"
              }}
            >
              {selectedService.title}
            </h2>

            {/* Inquiry Badge */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: isDarkMode ? "rgba(255,68,68,0.15)" : "#FFF5F5",
                padding: "6px 16px",
                borderRadius: "30px",
                marginBottom: "20px"
              }}
            >
              <FaInfoCircle size={12} color="#FF4444" />
              <span style={{ fontSize: "12px", color: "#FF4444", fontWeight: "500" }}>
                Service Inquiry
              </span>
            </div>

            {/* Message */}
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
                color: isDarkMode ? "#cbd5e1" : "#4a5568",
                marginBottom: "20px"
              }}
            >
              Thank you for your interest in our{' '}
              <strong style={{ color: "#FF4444" }}>{selectedService.title}</strong>{' '}
              service. To help us understand your requirements better and provide you 
              with the best possible solution, please connect with our team through the 
              <strong style={{ color: "#FF4444" }}> Contact Section</strong>.
            </p>

            {/* What We'll Discuss */}
            <div
              style={{
                background: isDarkMode ? "rgba(255,255,255,0.05)" : "#f8fafc",
                padding: "16px",
                borderRadius: "12px",
                marginBottom: "25px",
                textAlign: "left"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                <FaComments size={14} color="#FF4444" />
                <span style={{ fontSize: "13px", fontWeight: "600", color: isDarkMode ? "#fff" : "#1a1f36" }}>
                  We'll discuss:
                </span>
              </div>
              <ul style={{ margin: 0, paddingLeft: "20px", fontSize: "13px", color: isDarkMode ? "#94a3b8" : "#4a5568" }}>
                <li>✓ Your specific project requirements</li>
                <li>✓ Timeline and delivery expectations</li>
                <li>✓ Custom pricing and packages</li>
                <li>✓ Any questions you may have</li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div
              style={{
                display: "flex",
                gap: "15px",
                justifyContent: "center",
                flexWrap: "wrap"
              }}
            >
              <button
                onClick={handleGoToContact}
                style={{
                  padding: "12px 32px",
                  borderRadius: "40px",
                  border: "none",
                  background: "linear-gradient(135deg, #FF4444, #FF6B6B)",
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 5px 15px rgba(255,68,68,0.3)"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 10px 25px rgba(255,68,68,0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 5px 15px rgba(255,68,68,0.3)";
                }}
              >
                Go to Contact Section
                <FaArrowRight size={14} />
              </button>

              <button
                onClick={() => setShowPopup(false)}
                style={{
                  padding: "12px 32px",
                  borderRadius: "40px",
                  border: `2px solid ${isDarkMode ? "#FF4444" : "#FF4444"}`,
                  background: "transparent",
                  color: isDarkMode ? "#FF4444" : "#FF4444",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#FF4444";
                  e.currentTarget.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = isDarkMode ? "#FF4444" : "#FF4444";
                }}
              >
                Cancel
              </button>
            </div>

            {/* Response Time Note */}
            <p
              style={{
                fontSize: "11px",
                color: isDarkMode ? "#64748b" : "#a0aec0",
                marginTop: "20px",
                marginBottom: 0
              }}
            >
              ⚡ Our team typically responds within 24 hours
            </p>
          </div>
        </div>
      )}

      <section
        id="services"
        style={{
          padding: "80px 20px",
          textAlign: "center",
          color: sectionTextColor,
          background: sectionBackground
        }}
      >
        <h2 style={{ fontSize: "42px", marginBottom: "10px" }}>
          Our Services
        </h2>

        <p style={{ marginBottom: "50px", opacity: 0.7 }}>
          Professional digital solutions to grow your business
        </p>

        <div
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px,1fr))",
            gap: "25px"
          }}
        >
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => handleCardClick(service)}
              style={{
                padding: "30px",
                borderRadius: "18px",
                background: getBackgroundColor(index),
                boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                transition: "all 0.35s ease",
                cursor: "pointer",
                transform: hoverIndex === index || activeIndex === index
                  ? "translateY(-5px)"
                  : "translateY(0)",
                position: "relative"
              }}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
              onMouseDown={() => setActiveIndex(index)}
              onMouseUp={() => setActiveIndex(null)}
            >
              {/* Badge for services with details page */}
              {service.hasDetails && (
                <div
                  onClick={(e) => handleServiceClick(service, e)}
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    background: "linear-gradient(135deg, #10B981, #059669)",
                    padding: "4px 10px",
                    borderRadius: "20px",
                    fontSize: "10px",
                    fontWeight: "600",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    boxShadow: "0 2px 8px rgba(16,185,129,0.3)",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.background = "linear-gradient(135deg, #059669, #047857)";
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.background = "linear-gradient(135deg, #10B981, #059669)";
                  }}
                >
                  <FaInfoCircle size={10} />
                  <span>View Info</span>
                </div>
              )}

              <div style={{ marginBottom: "15px", display: "flex", justifyContent: "center" }}>
                {service.icon}
              </div>

              <h3 style={{ marginBottom: "10px", fontSize: "18px" }}>
                {service.title}
              </h3>

              <p style={{ fontSize: "14px", opacity: 0.85, lineHeight: "1.6" }}>
                {service.desc}
              </p>

              <div style={{ marginTop: "18px", display: "flex", justifyContent: "center" }}>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleServiceClick(service, e);
                  }}
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,#F43F5E,#EF4444)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.25)",
                    cursor: "pointer",
                    transition: "transform 0.2s ease"
                  }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    e.currentTarget.style.transform = "scale(1.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <FaShoppingCart size={15} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CSS Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </>
  );
};

export default Services;